export const COMPANY_INFO = {
  DOT_NUMBER: '3837801',
  SCAC_CODE: 'AEFK',
  LEGAL_NAME: 'ADG2 Transport Corp',
  HEADQUARTERS: 'New Jersey, USA',
  FLEET_SIZE: '50+',
  YEARS_IN_OPERATION: '10+',
} as const

export const EMAIL_ADDRESSES = {
  QUOTES: 'dispatch@adg2transport.com',
  APPLICATIONS: 'careers@adg2transport.com',
  EDI: 'edi@adg2transport.com',
  GENERAL: 'info@adg2transport.com',
} as const

export const API_ROUTES = {
  SUBMIT_QUOTE: '/api/submit-quote',
  SUBMIT_APPLICATION: '/api/submit-application',
  SUBMIT_EDI: '/api/submit-edi-inquiry',
} as const

export const FORMSPREE_FORM_IDS = {
  QUOTES: process.env.NEXT_PUBLIC_FORMSPREE_QUOTES_ID ?? '',
  APPLICATIONS: process.env.NEXT_PUBLIC_FORMSPREE_APPS_ID ?? '',
  EDI: process.env.NEXT_PUBLIC_FORMSPREE_EDI_ID ?? '',
  SHIPPERS: process.env.NEXT_PUBLIC_FORMSPREE_SHIPPERS_ID ?? '',
} as const

export const AIRTABLE_CONFIG = {
  API_KEY: process.env.AIRTABLE_API_KEY ?? '',
  BASE_ID: process.env.AIRTABLE_BASE_ID ?? '',
  TABLE_NAME: 'Jobs',
  VIEW_NAME: 'Published',
  ISR_REVALIDATE_SECONDS: 300,
} as const

export const RATE_LIMIT = {
  SUBMISSIONS_PER_IP: 1,
  WINDOW_MINUTES: 10,
} as const

export const RETRY_CONFIG = {
  MAX_ATTEMPTS: 3,
  BACKOFF_MS: [10_000, 20_000, 40_000],
} as const

export const POSTHOG_CONFIG = {
  API_KEY: process.env.NEXT_PUBLIC_POSTHOG_API_KEY ?? '',
  API_HOST: 'https://us.posthog.com',
} as const

export const ANIMATION_CONFIG = {
  HERO_TOTAL_FRAMES: 90,
  HERO_FPS: 24,
  PLACEHOLDER_KB: 5,
  HIGH_RES_KB: 20,
  HERO_BASE_PATH: '/images/hero-frames',
} as const

export const POSTHOG_EVENTS = {
  QUOTE_SUBMIT: 'quote_request_submit',
  EDI_CONTACT_CLICK: 'edi_contact_click',
  JOB_APPLY_SUBMIT: 'job_apply_submit',
  JOB_LISTING_VIEW: 'job_listing_view',
  PAGE_VIEW: 'page_view',
  CANVAS_SCROLL_50: 'canvas_scroll_50_percent',
  SHIPPER_INQUIRY: 'shipper_inquiry_submit',
} as const
